import { Feedback } from 'shared/components/Feedback'
import styled from 'styled-components'

import Button from 'shared/components/Button'

export const ContainerForm = styled.div`
  display: flex;

  flex: 1;

  flex-direction: column;
  align-items: center;

  input {
    min-width: 513px;
  }
`

export const StyledButton = styled(Button)`
  position: absolute;
  bottom: 20px;

  @media (max-width: 1377px) {
    position: relative;
    bottom: -190px;
  }

  @media (max-height: 668px) {
    bottom: -160px;
  }
`

export const StyledFeedback = styled(Feedback)`
  padding-bottom: 65px;
`
